<dx-calendar #PhxCalendarComponent [value]="value" [disabled]="disabled" [min]="min" [max]="max" [rtlEnabled]="rtlEnabled"
  [readOnly]="readOnly" [showTodayButton]="showTodayButton" (onValueChanged)="onValueChangedHandler($event)"
  [width]="width" [maxZoomLevel]="maxZoomLevel" [minZoomLevel]="minZoomLevel"
  (isValidChange)="isValidChangeHandler($event)" [cellTemplate]="cellTemplate">
  
  <span *dxTemplate="let cell of 'custom'" [ngClass]="getCellCssClass(cell.date)">
    {{cell.text}}
</span>
</dx-calendar>
